export var ERepeatPolicy = /*#__PURE__*/function (ERepeatPolicy) {
  ERepeatPolicy["OnError"] = "onError";
  ERepeatPolicy["Always"] = "always";
  return ERepeatPolicy;
}({});